import { zodResolver } from "@hookform/resolvers/zod"
import { useNavigate } from "@tanstack/react-router"
import { useCreateWhatsappOpeningMessageMutation } from "modules/campaigns/hooks/sections/openingMessages/useCreateWhatsappOpeningMessageMutation"
import { useForm } from "react-hook-form"
import { SearchSchema } from "routes/_base/_auth/settings/channels/whatsapp/openings"
import { UpsertWhatsappOpeningMessageSchema } from "schema"
import z from "zod"
import { WhatsappOpeningMessageForm } from "./WhatsappOpeningMessageForm"

export const WhatsappOpeningMessageCreate = () => {
  const navigate = useNavigate()
  const { mutateAsync, isPending } = useCreateWhatsappOpeningMessageMutation()
  const form = useForm<z.infer<typeof UpsertWhatsappOpeningMessageSchema>>({
    resolver: zodResolver(UpsertWhatsappOpeningMessageSchema),
    defaultValues: {
      identifier: "",
      text: "",
      locale: "",
    },
    disabled: isPending,
  })

  const onSubmit = async (data: z.infer<typeof UpsertWhatsappOpeningMessageSchema>) => {
    await mutateAsync({ props: data }).then(() => {
      navigate({ to: "/settings/channels/whatsapp/openings", search: SearchSchema.parse({}) })
    })
  }

  return <WhatsappOpeningMessageForm form={form} onSubmit={onSubmit} />
}
